import React, { useRef } from 'react';
import { SearchBox } from 'tea-component';
import { useIntl } from 'umi';

export default function Search(props: any) {
  const { gameType, searchGame, isclear, searchValue, setSearchValues } = props;

  const debounce = useRef({ interval: 0, delay: 200 }).current;
  const { formatMessage } = useIntl();
  const search = (value: any) => {
    searchGame(value, gameType);
  };

  const debounceChange = (value: string) => {
    clearTimeout(debounce.interval);
    debounce.interval = setTimeout(() => {
      searchGame(value, gameType);
    }, debounce.delay);
  };

  return (
    <>
      <SearchBox
        className="games-search"
        placeholder={formatMessage({ id: 'dbi_search_any_game' })}
        onSearch={search}
        onChange={(value) => {
          setSearchValues(value);
          debounceChange(value);
        }}
        value={searchValue}
      />
    </>
  );
}
